/**
 * Profile routing
 */
/* STORES */
import { useAuthStore } from '@/stores/auth';
const createDynamicRedirect = (newView: string, newSection?: string) => to => {
  // Redirect to new profile
  const params = {
    uuid: to.params.uuid,
    view: newView,
    section: newSection || undefined,
    anchor: to.params.matchUuid || undefined
  };

  const query: { pmUuid?: string } = {};
  if (to.params.pmUuid) query.pmUuid = to.params.pmUuid;
  return {
    name: 'profile',
    params,
    query
  };
};

export const PROFILE = {
  // UUID is not required though (cdt and recruiter paths)
  path: 'profile/:uuid([a-z0-9]{32})?',
  name: 'profilePage',
  component: () => import('@/views/recruiter/ProfileView.vue'),
  children: [
    {
      path: ':view?/:section?/:anchor?',
      name: 'profile',
      component: () => import('@/views/recruiter/ProfileView.vue'),
      beforeLeave: to => {
        return {
          name: to.name,
          params: { ...to.params },
          query: undefined
        };
      }
    },
    {
      path: 'predict/:pmUuid([a-z0-9]{32})?',
      name: 'profile_predict_old',
      component: { template: '<div></div>' }, // Fake component for ts
      beforeEnter: to => {
        // Redirect to new profile with view and section in params
        return {
          name: 'profile',
          params: {
            uuid: to.params.uuid,
            view: 'synthesis',
            section: 'predict'
          },
          query: {
            id: to.params.pmUuid
          }
        };
      }
    },
    {
      path: 'synthesis',
      name: 'profile-synthesis',
      redirect: createDynamicRedirect('synthesis')
    },
    {
      path: 'predict/:pmUuid([a-z0-9]{32})?',
      name: 'profile-predict',
      redirect: createDynamicRedirect('synthesis', 'predict')
    },
    {
      path: 'competency',
      name: 'profile-competency',
      redirect: createDynamicRedirect('competency')
    },
    {
      path: 'affinity/:matchUuid?',
      name: 'profile-affinity',
      redirect: createDynamicRedirect('synthesis', 'affinity')
    },
    {
      path: 'career-path',
      name: 'profile-career-path',
      redirect: createDynamicRedirect('synthesis')
    },
    {
      path: 'france-travail',
      name: 'profile-france-travail',
      redirect: createDynamicRedirect('france-travail')
    }
  ],
  beforeEnter: (to, from) => {
    // Handle auto redirection to auth urls for profile
    const auth = useAuthStore().getFullUser;
    if (!to.params?.uuid) {
      // Redirect to recruiter profile without uuid
      return { name: to.name, params: { ...from.params, uuid: auth.uuid } };
    }
  }
};
